<template>
    <div class="m-pop">
        <div class="pop-mask"></div>
        <div class="pop-con">
            <div class="title">
                <h3>用户登录</h3>
                <div class="close" @click="close">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <div class="form">
                <el-form :model="loginForm" :rules="loginRules" ref="loginForm">
                    <el-form-item prop="nickname" label="用户名">
                        <el-input
                            v-model="loginForm.nickname"
                            name="nickname"
                            autocomplete="nickname"
                            prefix-icon="el-icon-user-solid"
                            placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item prop="password" label="密码">
                        <el-input
                            v-model="loginForm.password"
                            name="password"
                            autocomplete="current-password"
                            prefix-icon="el-icon-lock"
                            type="password" placeholder="请输入密码"></el-input>
                    </el-form-item>
                </el-form>
<!--                记住我，忘记密码-->
                <div class="row">
                    <el-checkbox v-model="loginForm.rememberMe">记住我</el-checkbox>
                    <span class="forget-pwd">忘记密码？</span>
                </div>
                <el-button type="primary" class="submit-btn" @click="handleLogin">登录</el-button>
                <div class="tips">
                    还没有账号？<span @click="openReg">立即注册</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            loginForm: {
                nickname: '',
                password: '',
                rememberMe: false
            },
            loginRules: {
                nickname: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                    { min: 3, max: 20, message: '用户名长度在 3 到 20 个字符', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
                ]
            }
        }
    },
    methods:{
        ...mapActions(['login', 'getUserInfo']),
        close:function () {
            this.$emit('close')
        },
        openReg:function () {
            this.$emit('openReg')
        },
        handleLogin() {
            this.$refs.loginForm.validate(async (valid) => {
                if (valid) {
                    try {
                        await this.login({
                            nickname: this.loginForm.nickname,
                            password: this.loginForm.password
                        })
                        // 登录成功后获取最新的用户信息，确保头像等信息是最新的
                        await this.getUserInfo()
                        this.$message.success('登录成功')
                        this.close()
                    } catch (error) {
                        console.error('登录失败:', error)
                        console.error('错误详情:', error.response)
                        console.error('错误数据:', error.response?.data)
                        
                        let errorMsg = '登录失败'
                        const errorData = error.response?.data
                        
                        if (errorData && errorData.message) {
                            const message = errorData.message
                            
                            if (message.includes('用户名或密码错误') || message.includes('Invalid credentials')) {
                                errorMsg = '用户名或密码错误，请检查后重试'
                            } else if (message.includes('用户不存在')) {
                                errorMsg = '用户不存在，请先注册'
                            } else {
                                errorMsg = errorData.message
                            }
                        } else {
                            errorMsg = error.message || '登录失败'
                        }
                        
                        this.$message.error(errorMsg)
                    }
                } else {
                    return false
                }
            })
        }
    }
}
</script>



<style scoped lang="scss">


</style>
